import Model from "../../models/model";
import IRepo from "../../interfaces/repo";
import SingleSelectedDecorator from "./singleSelectedDecorator";

export default class SingleSelectedProperty<T extends Model> extends SingleSelectedDecorator<T> implements ISelectedProperty {
  constructor(propertyName: string, modelTypeGetter: () => new (...args) => T, afterSet?: () => void) {
    super(propertyName, modelTypeGetter, afterSet);
  }

  hasId(id: string): boolean {
    const item = this.get();
    return item && item.clientIdOrId === id;
  }

  setById(id: string): void {
    const item = this.repo.find(id);
    this.set(item);
  }

  private get repo(): IRepo<T> {
    return <IRepo<T>>(<any>this.modelTypeGetter()).repo;
  }
}

export interface ISelectedProperty {
  deselectIf(item: object): void;
  set(item: object): void;
  is(item: object): boolean;
}